<div class="tour-guide-tooltip" [attr.data-position]="positionClass">
  <div class="tooltip-header">
    <div class="tooltip-title">
      <i class="icon-info-o"></i>
      <span>{{ header }}</span>
    </div>
    <button type="button" class="close-btn" (click)="onClose()" aria-label="Close">
      <i class="icon-close"></i>
    </button>
  </div>
  <div class="tooltip-content" [innerHTML]="text"></div>
</div>
